import React from "react";
import "animate.css";

const HeroSection = () => {
  return (
    <div
      className="relative w-full overflow-hidden flex items-center justify-center bg-cover max-h-[960px] h-[700px] sm:h-[760px] 2xl:h-[960px] overflow-x-hidden"
      style={{ backgroundImage: "url(/img/fond-bannière.webp)" }}
    >
      <div className="flex flex-col text-center">
        <div className="flex flex-row items-center justify-center">
          <img
            src="/img/Formes_gauche.webp"
            alt="logo"
            className="absolute left-[-300px] sm:left-[-270px] md:left-[-200px] lg:left-[-130px] 2xl:left-0 max-w-fit h-[101%]"
            style={{ height: "[101%]" }}
            width="593.44"
            height="1100"
          />
          <section className="flex flex-row justify-center z-20">
            <img
              src="/img/Logo_noir.webp"
              alt="logo"
              className="absolute top-[28%] w-[78%] sm:w-[54%] lg:w-[40%] xl:w-[37%] 2xl:w-[450px]"
              width="450"
              height="150.47"
            />
            <div className="flex flex-col mt-[29.75rem] sm:mt-[31.75rem] 2xl:mt-[38.75rem] text-white items-center">
              <h1 className="text-[20px]  sm:text-[24px]">Baptiste BOULÉ</h1>
              <div className="border-t border-white rounded-2xl my-2 w-[85%] sm:w-[60%]"></div>

              <h2 className="pt-3 text-[16px] sm:text-[20px]">
                Coach sportif & <br className="sm:hidden" />
                Diététicien nutritionniste diplômé
              </h2>
              <p className=" text-[16px] sm:text-[20px]">
                Professionnel depuis 2020
              </p>
            </div>
          </section>

          <img
            src="/img/Formes_droite.webp"
            alt="logo"
            className="absolute right-[-300px] sm:right-[-270px] md:right-[-200px] lg:right-[-130px] max-w-fit h-[101%]"
            style={{ height: "[101%]" }}
            width="700"
            height="1100"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
